const GraphQLQuery = require('app/graphql/Query');

class SupplierSelect {

    defaultOptions(){
        return {
            '$select': $('<select/>'),
            'value' : '',

            'onChange': function(event,$select){},

            'cacheKey': 'suppliers',
        };
    }
    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onChange = this.onChange.bind(this);

        this.$select  = this.settings.$select;
        this.value = this.settings.value;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.$select.on('change',this.onChange);

        let suppliers = window.getFromCache(this.settings.cacheKey);
        if(suppliers){
            this.fillSelect(suppliers);
        }else{
            this.loadData();
        }
    }

    loadData(){
        var self = this;


        let filters = {
            'enable': true,
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'filter': filters,
            'orderBy': 'name',
            'dir': 'ASC',
        };

        let fields = [
            'id',
            'name'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'suppliers',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
            //callbacks
            'before': function(){
            },
            'success': function(data){
                let items = data.edges;
                window.addToCache(self.settings.cacheKey,items);
                self.fillSelect(items);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    fillSelect(suppliers){
        this.suppliers = suppliers;


        this.$select.html('');


        this.$select
        .append(
            $('<option/>')
            .val('')
            .append('-')
        );

        for(var i in this.suppliers){
            let supplierItem = this.suppliers[i];

            let value = supplierItem.node.id;
            let label = supplierItem.node.name;

            let $option = $('<option/>')
            .val(value)
            .append(label);

            if(this.value == value){
                $option.attr('selected','selected');
            }

            this.$select.append($option);

        }
    }

    onChange(event){
        this.value = this.$select.val();
        this.settings.onChange(event,this.$select);
    }
}

module.exports = SupplierSelect;

